'use client';

import { getClassNames } from '@websolutespa/bom-core';
import { useWindowSize } from '@websolutespa/bom-mixer-hooks';
import { IconLlmArrowLeft, IconLlmArrowRight } from '@websolutespa/bom-mixer-icons';
import { useRef } from 'react';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { LlmBlock, LlmChunkProductGroup } from '../../../types';
import { clamp } from '../../utils';
import { Product } from '../Product/product';

export const ProductGroupSlider: React.FC<LlmBlock<LlmChunkProductGroup>> = (props) => {
  const { item } = props;

  useWindowSize();

  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const swiperProps = {
    modules: [Navigation],
    spaceBetween: clamp(16, 24),
    slidesPerView: 'auto' as const,
    slidesPerGroup: 1,
    watchOverflow: true,
    centeredSlides: false,
    navigation: {
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current,
    },
    breakpoints: {
      630: {
        // slidesPerView: 1.5,
        slidesPerGroup: 1,
      },
      768: {
        // slidesPerView: 1.5,
        slidesPerGroup: 1,
      },
      1024: {
        // slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1280: {
        // slidesPerView: 3,
        slidesPerGroup: 3,
      },
    },
  };

  const classNames = getClassNames('llm__products');
  return (
    <div className={classNames}>
      <Swiper {...swiperProps}>
        <div className="llm__products-nav">
          <button ref={navigationPrevRef}><IconLlmArrowLeft /></button>
          <button ref={navigationNextRef}><IconLlmArrowRight /></button>
        </div>
        {item.items.map((item, i) => (
          <SwiperSlide key={i} className="llm__products-slide">
            <Product {...props} item={item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

